function syncLoadingFlag(state) {
  state.isLoading = state.loadingRequestCount > 0;
}

export default {
  namespaced: true,
  state: {
    isLoading: false,
    /** Nested $loader.show/hide calls (e.g. tab switch while a fetch is finishing). */
    loadingRequestCount: 0,
    loaderType: "default",
    appLoading: false,
    maintenanceMode: false,
  },
  mutations: {
    incrementLoading(state) {
      state.loadingRequestCount += 1;
      syncLoadingFlag(state);
    },
    decrementLoading(state) {
      state.loadingRequestCount = Math.max(0, state.loadingRequestCount - 1);
      syncLoadingFlag(state);
    },
    setLoading(state, status) {
      if (status) {
        state.loadingRequestCount += 1;
      } else {
        state.loadingRequestCount = 0;
      }
      syncLoadingFlag(state);
    },
    setLoaderType(state, value) {
      state.loaderType = value;
    },
    setAppLoading(state, status) {
      state.appLoading = status;
    },
    setMaintenanceMode(state, status) {
      state.maintenanceMode = status;
    },
  },
  actions: {
    setLoadingStatus({ commit }, status) {
      commit("setLoading", status);
    },
  },
  getters: {
    getLoadingStatus(state) {
      return state.isLoading;
    },
    getLoaderType(state) {
      return state.loaderType;
    },
  },
};
